import {MenuItem, Message, Steps} from 'primeng/primeng';

export interface MenuItemEx extends MenuItem {
  me: any;
}

export function itemClick(event: Event, item: MenuItemEx, i: number): void {
  if (this.readonly || item.disabled) {
    event.preventDefault();
    return;
  }

  if (i > item.me.activeIndex) {
    item.me.canGoNext(() => {
      if (!item.url) {
        event.preventDefault();
      }
      if (item.command) {
        item.command({
          originalEvent: event,
          item: item,
          index: i
        });
      }
    }, () => {
      event.preventDefault();
    });
  } else {

    if (!item.me.canGoPrevious()) {
      event.preventDefault();
      return;
    }

    if (!item.url) {
      event.preventDefault();
    }

    if (item.command) {
      item.command({
        originalEvent: event,
        item: item,
        index: i
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/menu-item-ex.ts